import { Button, CircularProgress, Paper } from '@mui/material';
import AppPaperContent from 'src/app/common/components/AppPaperContent';
import useStyles from './BachFileActions.styles';
import { useTranslation } from 'src/app/common/hook/translation.hook';
import { usePoliciesApprovalRequestPageContext } from '../../PoliciesApprovalRequestPage.context';

const BachFileActions = () => {
  const t = useTranslation();
  const { isSubmitting, selectedPolicyIds, sendBackPolicies, rejectPolicies, approvePolicies } =
    usePoliciesApprovalRequestPageContext();
  const { classes } = useStyles();

  return (
    <Paper>
      <AppPaperContent className={classes.paperContent}>
        <Button
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          variant="contained"
          color="error"
          onClick={sendBackPolicies}
          disabled={isSubmitting || selectedPolicyIds.length === 0}
        >
          {t('opm_pd.sendBack')}
        </Button>
        <Button
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          variant="contained"
          color="error"
          onClick={rejectPolicies}
          disabled={isSubmitting || selectedPolicyIds.length === 0}
        >
          {t('opm_pd.reject')}
        </Button>
        <Button
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          variant="contained"
          color="secondary"
          onClick={approvePolicies}
          disabled={isSubmitting || selectedPolicyIds.length === 0}
        >
          {t('opm_pd.approve')}
        </Button>
      </AppPaperContent>
    </Paper>
  );
};

export default BachFileActions;
